module.exports = __webpack_public_path__ + "media/images/captive_portal/VenuTRAX-logo-0502ed3b7c53fecd004a35f459de8e33.png";